import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function useBrands(params = {}) {
  return useQuery({
    queryKey: ["brands", params],
    queryFn: async () => (await api.get("/brands", { params })).data,
  });
}

export function useBrand(slug) {
  return useQuery({
    queryKey: ["brand", slug],
    queryFn: async () => (await api.get(`/brands/${slug}`)).data,
    enabled: !!slug,
    retry: false,
  });
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => (await api.get("/categories")).data,
  });
}

export function useNavPages() {
  return useQuery({
    queryKey: ["nav-pages"],
    queryFn: async () => (await api.get("/pages/nav")).data,
  });
}

export function useFooterPages() {
  return useQuery({
    queryKey: ["footer-pages"],
    queryFn: async () => (await api.get("/pages/footer")).data,
  });
}

export function useSettings() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
}
